import { useMemo } from 'react';
import type { Agency } from '~/common/types';
import Input from '~/components2/forms/Input';
import FormSection from '~/pages/admin/civilsearch/common/FormSection';

interface Config {
  label: string;
  field: keyof Agency;
  custom?: (val: any) => string | number;
}

export const config: Config[] = [
  { label: 'Agency Type', field: 'type' },
  { label: 'Database ID', field: 'id' },
  {
    label: 'Published',
    field: 'isPublished',
    custom: (p) => (p ? '✅' : '❌'),
  },
  { label: 'ESRI Object ID', field: 'objectId' },
];

interface Props {
  agency: Agency;
}

export default function StaticInfo({ agency }: Props) {
  const items = useMemo(() => {
    return config.map((item, i) => {
      let value = agency[item.field];

      if (value && item.custom) {
        value = item.custom(value);
      }

      return (
        <Input
          // biome-ignore lint/suspicious/noArrayIndexKey: legacy
          key={`general-static-${i}`}
          label={item.label}
          value={value?.toString()}
          disabled
          canCopy
        />
      );
    });
  }, [agency]);

  return (
    <FormSection title="Agency ID and Information">
      <div className="grid grid-cols-3 gap-2">{items}</div>
    </FormSection>
  );
}
